import * as stylex from '@stylexjs/stylex';
import '@astryxdesign/core/theme/tokens.stylex';
import { colorVars, radiusVars } from '@astryxdesign/core/theme/tokens.stylex';
export const liquidGlass = {
  surface: {
    kWkggS: "x19s24ia",
    k6WDB: "xjdu6xw",
    keRtuK: "xktulrp",
    $$css: true
  },
  pane: {
    kWkggS: "x1pzrbks",
    kKwaWg: "x17aulxs",
    k6WDB: "xs4b8i9",
    keRtuK: "x1yghftu",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xz10nam",
    kaIpWk: "x1hviunn",
    kGVxlE: "x108hkvl",
    $$css: true
  },
  pill: {
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1anrmt5",
    kaIpWk: "xh6dtrn",
    kWkggS: "x1ladqqo",
    kKwaWg: "xrc60gg",
    kGVxlE: "x1m4r70y",
    k6WDB: "x2bs0b7",
    keRtuK: "xn71lxt",
    $$css: true
  },
  tile: {
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x15boqcr",
    kaIpWk: "xh6dtrn",
    kWkggS: "x1vmoeur xgd3vc4",
    kKwaWg: "x1o276rd",
    kGVxlE: "xmyhhby",
    $$css: true
  }
};